<template>
    <div v-click-outside='outsideClick' :class='{on: open}' class='ui-select'>
        <button type='button' @click='open = !open'>{{ selected }}</button>
        <ul>
            <li v-for='(val, index) in selectData' :key='index' :class='{on: selected == value.type}'
                @click='changeData(val.type, val.value)'>{{ val.type }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'SelectType',
    props: {
        selectData: Array,
    },
    data() {
        return {
            open: false,
            selected: '',
            value: '',
        };
    },
    mounted() {
    },
    created() {
        const index = 0;
        this.selected = this.selectData[index].type;
    },
    methods: {
        changeData(type, value) {
            this.open = false;
            this.selected = type;

            this.$emit('update:set', value);
        },
        outsideClick() {
            this.open = false;
        },
    },
};
</script>
<style lang='scss'>
@import "../assets/scss/mixin.scss";

.ui-select {
    display: inline-block;
    position: relative;
    width: 160px;
    height: 32px;

    & + .ui-select {
        margin-left: 8px;
    }

    &.on {
        ul {
            display: block;
        }
    }

    button {
        display: block;
        position: relative;
        width: 100%;
        padding-left: 8px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        text-align: left;
        color: #7e7777;

        &::after {
            content: "";
            position: absolute;
            right: 8px;
            top: 8px;

            @include ic-tri-arrow;
        }
    }

    ul {
        display: none;
        position: absolute;
        left: 0;
        top: 33px;
        width: 100%;
        padding: 12px 0;
        background: #fff;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        z-index: 1;

        li {
            display: block;
            height: 36px;
            padding: 0 22px;
            font-size: 13px;
            line-height: 36px;
            color: #545454;
            cursor: pointer;

            &.on {
                background-color: rgba(0, 199, 229, 0.1);
            }
        }
    }
}
</style>
